import React from 'react';
import { Label, MaskedField, ErrorMessage } from '../FormikCustom';

export default function SSNumber({ name, label, ...rest }) {
  return (
    <div className="form-group">
      <Label htmlFor={name}>{label}</Label>
      <MaskedField
        mask="9999"
        className="form-control"
        placeholder="ex. 1234"
        name={name}
        {...rest}
      />
      <ErrorMessage name={name} />
    </div>
  );
}
